
import { getTmpCdnKey } from '@/services/getData';
import { mapState } from 'vuex';
import codepku from '@/utils/codepku';
import moment from 'moment';

const { VUE_APP_CDN, VUE_APP_BUCKET, VUE_APP_REGION } = process.env;
export default {
  name: 'Upload',
  data() {
    return {
      cosBody: null,
      logText: '',
      Bucket: VUE_APP_BUCKET,
      Region: VUE_APP_REGION,
      mixinProgressPercent: 0,
      mixinCdnUrl: '',
    };
  },
  props: {
    fileInput: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    mixinUploadToCdn(file) {
      return new Promise((resolve, reject) => {
        console.log(file);
        if (!file) {
          console.log('no file');
          return;
        }
        this.progressNum = 0;
        let fileName = '';
        let fileType = '';
        let fileAppendix = '';
        if (file.name) {
          fileName = file.name;
          fileType = file.type.split('/')[0];
          fileAppendix = fileName.slice(fileName.lastIndexOf('.'), fileName.length);
        } else if (file.type) {
          fileName = fileType = file.type.split('/')[1];
          fileAppendix = `.${fileType}`;
        }
        const randomId = codepku.genUniqueId();
        const uniqueKey = `exam/video/${moment(new Date()).format('YYYY-MM-DD')}/${this.authority.admissionTicket}!${randomId}${fileAppendix}`;
        this.mixinCdnUrl = `${VUE_APP_CDN}/${uniqueKey}`;
        console.log(uniqueKey);
        const that = this;
        this.cosBody.putObject({
          Bucket: that.Bucket,
          Region: that.Region,
          Key: uniqueKey,
          Body: file,
          StorageClass: 'STANDARD',
          onProgress(data) {
            that.logText = JSON.stringify(data);
            console.log(data);
            if (data.percent > 0) {
              console.log(data.percent);
              if (data.percent * 100 >= 100) {
                console.log('cdn upload and resolved');
                resolve(that.mixinCdnUrl);
              }
            }
          },
        }, (err, data) => {
          if (err) {
            console.log(err);
            reject(err);
          } else {
            console.log(data);
            // console.log(this.cosBody);
            // resolve(this.mixinCdnUrl);
          }
        });
      });
    },
  },
  mounted() {
    console.log(this.cos);
    this.cosBody = new this.COSV5({
      getAuthorization(options, callback) {
        console.log(1122);
        getTmpCdnKey()
          .then((res) => {
            console.log(res);
            if (res) {
              callback({
                TmpSecretId: res.credentials.tmpSecretId,
                TmpSecretKey: res.credentials.tmpSecretKey,
                XCosSecurityToken: res.credentials.sessionToken,
                ExpiredTime: res.expiredTime,
              });
            }
          });
      },
    });
    console.log(this.cosBody, this.authority.admissionTicket);
  },
  computed: {
    ...mapState(['authority']),
  },
  watch: {
  },
};
